// extracted by mini-css-extract-plugin
export var body = "EventCard-module--body--bffd8";
export var byline = "EventCard-module--byline--49b2e";
export var category = "EventCard-module--category--89051";
export var categoryIcon = "EventCard-module--categoryIcon--d8e4d";
export var container = "EventCard-module--container--8e1a8";
export var excerpt = "EventCard-module--excerpt--cafd5";
export var image = "EventCard-module--image--92ba9";
export var isHorizontal = "EventCard-module--isHorizontal--298e7";
export var isPrimary = "EventCard-module--isPrimary--c4124";
export var title = "EventCard-module--title--71353";